import { unserialize } from 'php-serialize';

function looksPhpSerialized(s: string): boolean {
  const t = s.trim();
  if (t.length < 2) return false;
  return /^[abisNOC]:/.test(t) || t.startsWith('a:') || t.startsWith('O:');
}

/**
 * If value looks like PHP serialized data, return parsed JSON-friendly structure.
 */
export function parseMetaValue(raw: string): { value: unknown; wasSerialized: boolean } {
  const trimmed = (raw ?? '').trim();
  if (!trimmed) {
    return { value: '', wasSerialized: false };
  }
  if (!looksPhpSerialized(trimmed)) {
    return { value: raw, wasSerialized: false };
  }
  try {
    const parsed = unserialize(trimmed);
    return { value: parsed, wasSerialized: true };
  } catch {
    return { value: raw, wasSerialized: false };
  }
}

function walkForPaths(obj: unknown, out: string[], depth = 0): void {
  if (depth > 12) return;
  if (obj == null) return;
  if (typeof obj === 'string') {
    if (/\.(jpe?g|png|gif|webp|avif)(\?|$)/i.test(obj) || obj.includes('/wp-content/uploads/')) {
      out.push(obj);
    }
    return;
  }
  if (Array.isArray(obj)) {
    obj.forEach((v) => walkForPaths(v, out, depth + 1));
    return;
  }
  if (typeof obj === 'object') {
    for (const v of Object.values(obj as Record<string, unknown>)) {
      walkForPaths(v, out, depth + 1);
    }
  }
}

export function extractPathsFromUnserialized(value: unknown): string[] {
  const out: string[] = [];
  walkForPaths(value, out);
  return [...new Set(out)];
}
